
import { createContext, useState, useEffect } from 'react';

export const RegistrationContext = createContext();

export const RegistrationProvider = ({ children }) => {
    const [registrationData, setRegistrationData] = useState(() => {
        try {
            const savedData = sessionStorage.getItem('registrationData');
            return savedData ? JSON.parse(savedData) : {
                userType: 'fan',
                fullName: '',
                userPhone: '',
                userPassword: '',
                profilepicture: '',
                email: '',
            };
        } catch (error) {
            console.error('Error loading registration data from sessionStorage:', error);
            return {
                userType: 'fan',
                fullName: '',
                userPhone: '',
                userPassword: '',
                profilepicture: '',
                email: '',
            };
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem('registrationData', JSON.stringify(registrationData));
        } catch (error) {
            console.error('Error saving registration data to sessionStorage:', error);
        }
    }, [registrationData]);

    const updateRegistrationData = (newData) => {
        setRegistrationData(prev => ({ ...prev, ...newData }));
    };

    const clearRegistrationData = () => {
        setRegistrationData({
            userType: 'fan',
            fullName: '',
            userPhone: '',
            userPassword: '',
            profilepicture: '',
            email: '',
        });
        try {
            sessionStorage.removeItem('registrationData');
        } catch (error) {
            console.error('Error clearing registration data from sessionStorage:', error);
        }
    };

    return (
        <RegistrationContext.Provider value={{
            registrationData,
            updateRegistrationData,
            clearRegistrationData
        }}>
            {children}
        </RegistrationContext.Provider>
    );
};